var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1\xB7icon/*\u5E38\u7528/\u70ED\u95E8_fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1\\xB7icon/*\\u5E38\\u7528/\\u70ED\\u95E8_fill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fire-fill"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0328125,7.33125 C12.728125,6.646875 12.2921875,6.040625 11.7375,5.53125 L11.2828125,5.1140625 C11.215625,5.0546875 11.109375,5.08125 11.0796875,5.165625 L10.8765625,5.7484375 C10.75,6.1140625 10.5171875,6.4875 10.1875,6.8546875 C10.165625,6.878125 10.140625,6.884375 10.1234375,6.8859375 C10.10625,6.8875 10.0796875,6.884375 10.05625,6.8625 C10.034375,6.84375 10.0234375,6.815625 10.025,6.7875 C10.0828125,5.846875 9.8015625,4.7859375 9.1859375,3.63125 C8.6765625,2.671875 7.96875,1.9234375 7.084375,1.4015625 L6.4390625,1.021875 C6.3546875,0.971875 6.246875,1.0375 6.2515625,1.1359375 L6.2859375,1.8859375 C6.309375,2.3984375 6.25,2.8515625 6.109375,3.228125 C5.9375,3.6890625 5.690625,4.1171875 5.375,4.5015625 C5.153125,4.7703125 4.9046875,5.0125 4.6328125,5.221875 C3.975,5.7265625 3.4328125,6.384375 3.065625,7.1203125 C2.6953125,7.8640625 2.5,8.696875 2.5,9.53125 C2.5,10.26875 2.6453125,10.9828125 2.9328125,11.65625 C3.2109375,12.3046875 3.6078125,12.8890625 4.1125,13.3890625 C4.61875,13.8890625 5.20625,14.2828125 5.8609375,14.55625 C6.5390625,14.840625 7.2578125,14.984375 8,14.984375 C8.7421875,14.984375 9.4609375,14.840625 10.1390625,14.5578125 C10.79375,14.284375 11.3828125,13.8921875 11.8875,13.390625 C12.39375,12.890625 12.790625,12.30625 13.0671875,11.6578125 C13.3546875,10.984375 13.5,10.2703125 13.5,9.5328125 C13.5,8.7703125 13.34375,8.0296875 13.0328125,7.33125 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#F05B5B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.7a29bbaf.svg";
export { ForwardRef as ReactComponent };